import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import sheducle from './../actions/scheduleAPI'

const initialState = {
  data: [],
  total: 0,
  loading: false,
  detail:{},
  matches: []
};
export const fetchSchedule = createAsyncThunk(
  'schedule/fetchList',
  async (params, thunkAPI) => {
    const response = await sheducle.fetchShedules(params)
    return response.data
  }
);

export const fetchMatches = createAsyncThunk(
  'schedule/fetchMatch',
  async (params, thunkAPI) => {
    const response = await sheducle.fetchMatchs(params)
    return response.data
  }
);

export const scheduleSlice = createSlice({
  name: 'schedule',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSchedule.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSchedule.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.total = action.payload.total
      })
      .addCase(fetchMatches.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMatches.fulfilled, (state, action) => {
        state.loading = false;
        state.matches = action.payload.data;
      });
  },
});

export default scheduleSlice.reducer;
